export default "__VITE_ASSET__etDD7EE3__"